import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl';
import { signupConfirmation } from '../../containers/Auth/actions';
import ErrorComponent from '../../components/Error';
// images
import imgHeaderBg from '../../img/404-bg.png';
// translate
import messages from './messages';

class SignupConfirmationPage extends Component {
  componentWillMount() {
    this.checkCode();
  }

  checkCode() {
    const code = this.props.params.code;
    this.props.dispatch(signupConfirmation(code));
  }

  render() {
    const {
      intl,
      isFetching,
      signupConfirmationSuccess,
      signupConfirmationErrorMessage,
    } = this.props;

    return (
      <div>
        <div
          className="error-404-wrap container-fluid"
          style={{ backgroundImage: `url('${imgHeaderBg}')` }}
        >
          <div className="row">
            <div className="container">
              <div className="row">
                <div className="col-xs-12">
                  <div className="error-404-text">
                    {isFetching &&
                      <FormattedHTMLMessage {...messages.processText} />}
                    {signupConfirmationSuccess &&
                      <FormattedHTMLMessage {...messages.successText} />}
                    {signupConfirmationErrorMessage &&
                      !isFetching &&
                      <ErrorComponent>
                        {signupConfirmationErrorMessage}
                      </ErrorComponent>}
                    <br />
                    {signupConfirmationSuccess &&
                      <Link to="/#login">
                        {intl.formatMessage(messages.login)}
                      </Link>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SignupConfirmationPage.defaultProps = {
  signupConfirmationErrorMessage: false,
};

SignupConfirmationPage.propTypes = {
  intl: intlShape.isRequired,
  dispatch: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
  signupConfirmationErrorMessage: PropTypes.any,
  signupConfirmationSuccess: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    signupConfirmationErrorMessage: state.get('auth')
      .signupConfirmationErrorMessage,
    signupConfirmationSuccess: state.get('auth').signupConfirmationSuccess,
    isFetching: state.get('auth').isFetching,
  };
}

export default connect(mapStateToProps)(injectIntl(SignupConfirmationPage));



// WEBPACK FOOTER //
// ./src/pages/SignupConfirmationPage/index.js